export default __webpack_public_path__ + "static/media/AtomsAndCompounds _19.556eafac.png";